import React from 'react';
import { useMobile } from '../../../hooks/useMobile';
import DesktopTip from './DesktopTip';
import MobileTip from './MobileTip';

export default function Tip({ text, tooltip }) {
  const mobile = useMobile('sm');

  return (
    <>
      {mobile && <MobileTip summary={text} details={tooltip} />}
      {!mobile && <DesktopTip text={text} tooltip={tooltip} />}
    </>
  );
}
